import { Col } from 'antd';
import { Rule } from 'antd/lib/form';
import { useState } from 'react';

import { FormItem } from '../Form';
import { InputDynamicPhone } from '../InputDynamicPhone';

type FormItemDynamicPhoneProps = {
  colSpan?: number;
  required?: boolean;
};

export function FormItemDynamicPhone(props: FormItemDynamicPhoneProps) {
  const { colSpan, required } = props;
  const [isEmpty, setIsEmpty] = useState(false);

  function onChangeValue(e: any) {
    setIsEmpty(e.target.value === '+ __ (__) ____-____');
  }

  const getRules = () => {
    const rules: Rule[] = [];

    rules.push({ required, message: 'Campo obrigatório' });
    if (!isEmpty) {
      rules.push({
        pattern: /(\(\d{2}\)\s)?(\d{4,5}-\d{4})/,
        message: 'Informe um telefone válido',
      });
    }

    return rules;
  };

  return (
    <Col span={colSpan || 24}>
      <FormItem label="Telefone" name="phone_number" rules={getRules()}>
        <InputDynamicPhone onChange={onChangeValue} />
      </FormItem>
    </Col>
  );
}
